import React, { useMemo } from 'react';

import { CssModuleType } from '@utils/cssModules';

import currentCssModule from './Accordion.module.scss';
import AccordionItem from '../AccordionItem';
import { Facet, FacetData } from '../../types';
import { useModal } from '../../containers/ModalContext';

export interface AccordionProps extends React.HTMLAttributes<HTMLDivElement> {
    data: Facet[];
    activeFilters?: FacetData[];
    isItemActive?: (facetName: string, value: string) => boolean;
    onToggle?: Function;
}

const Accordion: React.FC<AccordionProps> = ({
    data,
    onToggle,
    activeFilters,
    isItemActive
}) => {
    const st: CssModuleType = currentCssModule;

    const { market } = useModal();

    const eligibleItem = data?.find(
        (item) =>
            item.name.startsWith('Price_') &&
            item.name.includes(`${market.MarketName}_All`)
    );

    const fallbackItem = data?.find(
        (item) =>
            item.name.startsWith('Price_') &&
            item.name === 'Price_Retailer US_All Customers'
    );

    const itemsToShow = eligibleItem
        ? [eligibleItem]
        : fallbackItem
        ? [fallbackItem]
        : [];

    const accordionItems = useMemo(() => {
        return data?.map((item) => {
            if (item.name.startsWith('Price_')) {
                if (!itemsToShow.includes(item)) {
                    return null;
                }
            }
            if (item.name.includes('Availability_Filter')) {
                return null;
            }
            return (
                <AccordionItem
                    data={item}
                    activeFilters={activeFilters}
                    onToggle={onToggle}
                    key={`accordion_item_${item.name}`}
                    isItemActive={isItemActive}
                />
            );
        });
    }, [data, activeFilters, onToggle, isItemActive]);

    return <div className={st.accordion}>{accordionItems}</div>;
};

export default Accordion;
